import { useContext } from 'react'
import { Skeleton } from '@mui/material'

import StatusChip from '../../../../components/status-chip'
import AccountsContext from '../../context'

const AccountStatusChip = ({ accountStatus, dataTestId }: { accountStatus: string; dataTestId?: string }) => {
  const { folderTree, isLoading } = useContext(AccountsContext)

  if (folderTree && !isLoading) return accountStatus ? <StatusChip size="medium" label={accountStatus} data-testid={dataTestId} /> : null

  return <Skeleton width="62px" height="32px" aria-label="Loading account status" />
}

export default AccountStatusChip
